import { createContext, useContext } from 'react';
import { MenuCalendarContextType } from './types';

const MenuCalendarContext = createContext<MenuCalendarContextType | undefined>(
	undefined,
);

const useCalendarDatepicker = () => {
	const context = useContext(MenuCalendarContext);
	if (!context) {
		throw new Error(
			'useCalendarMenu must be used within an MenuCalendarProvider',
		);
	}
	return context;
};

export { useCalendarDatepicker, MenuCalendarContext };
